<template>
  <div class="roles-list">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Admin / Roles</p>
            <h1 class="list-title">Gestión de Roles</h1>
            <p class="list-subtitle">
              Administre los roles y permisos del sistema.
            </p>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card class="roles-panel">
            <v-card-text class="roles-card__toolbar">
              <v-layout row wrap align-center>
                <v-flex md8 sm8 xs12>
                  <v-text-field
                    clearable
                    flat
                    hide-details
                    placeholder="Buscar rol..."
                    solo
                    class="roles-search"
                    v-model="search"
                    append-icon="search"
                    @keyup.enter="loadRoles"
                    @click:clear="onSearchClear"
                    @click:append="loadRoles"
                  ></v-text-field>
                </v-flex>
                <v-flex md4 sm4 xs12 class="toolbar-actions">
                  <v-btn
                    @click="openDialog()"
                    color="#e5252a"
                    dark
                    class="btn-nuevo"
                  >
                    <v-icon left>add</v-icon>Nuevo Rol
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text class="pa-0 roles-content-wrap">
              <!-- Desktop con paginación -->
              <v-data-table
                v-if="!$vuetify.breakpoint.smAndDown"
                class="roles-table"
                :headers="headers"
                :items="roles"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                rows-per-page-text="Filas por página:"
                no-data-text="No hay roles disponibles"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <div class="role-name-cell">
                      <span
                        class="role-color-dot"
                        :style="{ background: roleColor(props.item.code) }"
                      ></span>
                      {{ props.item.name }}
                    </div>
                  </td>
                  <td>
                    <span class="role-code-badge">{{ props.item.code }}</span>
                  </td>
                  <td>{{ props.item.description || '---' }}</td>
                  <td>
                    <v-chip
                      :class="
                        props.item.isActive
                          ? 'status-chip status-chip--active'
                          : 'status-chip status-chip--inactive'
                      "
                      text-color="white"
                      small
                    >
                      {{ props.item.isActive ? 'Activo' : 'Inactivo' }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      @click="openDialog(props.item)"
                      class="table-action-btn table-action-btn--edit"
                      flat
                      icon
                      small
                      title="Editar rol"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      @click="openMenusDialog(props.item)"
                      class="table-action-btn table-action-btn--menus"
                      flat
                      icon
                      small
                      title="Asignar menús"
                    >
                      <v-icon>list</v-icon>
                    </v-btn>
                    <v-btn
                      @click="openDeleteRoleModal(props.item)"
                      class="table-action-btn table-action-btn--delete"
                      flat
                      icon
                      small
                      title="Eliminar rol"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template slot="pageText" slot-scope="props">
                  {{ props.pageStart }}-{{ props.pageStop }} de
                  {{ props.itemsLength }}
                </template>
              </v-data-table>

              <!-- Mobile -->
              <div v-else class="roles-mobile-list">
                <v-container fluid class="pa-3">
                  <v-layout row wrap>
                    <v-flex xs12 v-if="!roles.length && !loading">
                      <v-alert type="info" value="true" class="mb-0">
                        No hay roles disponibles.
                      </v-alert>
                    </v-flex>
                    <v-flex
                      xs12
                      v-for="role in paginatedRoles"
                      :key="role.id"
                      class="mb-3"
                    >
                      <v-card class="role-mobile-card">
                        <div
                          class="role-mobile-card__head"
                          :style="{ '--role-color': roleColor(role.code) }"
                        >
                          <div class="role-mobile-card__head-main">
                            <p class="role-mobile-card__title">
                              {{ role.name }}
                            </p>
                            <span
                              class="role-code-badge role-code-badge--inverse"
                            >
                              {{ role.code }}
                            </span>
                          </div>
                          <v-chip
                            :class="
                              role.isActive
                                ? 'status-chip status-chip--active'
                                : 'status-chip status-chip--inactive'
                            "
                            text-color="white"
                            small
                          >
                            {{ role.isActive ? 'Activo' : 'Inactivo' }}
                          </v-chip>
                        </div>
                        <v-divider></v-divider>
                        <div class="role-mobile-card__body">
                          <div class="role-mobile-card__row">
                            <span class="label">Descripción</span>
                            <span class="value">{{
                              role.description || '---'
                            }}</span>
                          </div>
                          <div
                            class="role-mobile-card__row"
                            v-if="role.createdAt"
                          >
                            <span class="label">Creado</span>
                            <span class="value">{{
                              formatDate(role.createdAt)
                            }}</span>
                          </div>
                        </div>
                        <div class="role-mobile-card__actions">
                          <v-btn
                            small
                            dark
                            color="#254f87"
                            class="mobile-action-btn"
                            @click="openDialog(role)"
                          >
                            <v-icon small left>edit</v-icon>Editar
                          </v-btn>
                          <v-btn
                            small
                            dark
                            color="#c79a2b"
                            class="mobile-action-btn"
                            @click="openMenusDialog(role)"
                          >
                            <v-icon small left>list</v-icon>Menús
                          </v-btn>
                          <v-btn
                            small
                            dark
                            color="#e5252a"
                            class="mobile-action-btn"
                            @click="openDeleteRoleModal(role)"
                          >
                            <v-icon small left>delete</v-icon>
                          </v-btn>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <div v-if="totalPages > 1" class="mobile-pagination">
                    <v-pagination
                      v-model="pagination.page"
                      :length="totalPages"
                      :total-visible="5"
                      color="#e5252a"
                    ></v-pagination>
                  </div>
                </v-container>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog crear/editar rol -->
    <v-dialog max-width="600" persistent v-model="dialog">
      <v-card class="role-dialog-card">
        <v-card-title class="role-dialog-title">
          <v-icon left color="#254f87">{{
            editingRole.id ? 'edit' : 'add_circle'
          }}</v-icon>
          {{ editingRole.id ? 'Editar Rol' : 'Nuevo Rol' }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="editingRole.name"
              label="Nombre"
              placeholder="Ej: Administrador"
              required
              :rules="[v => !!v || 'El nombre es requerido']"
            ></v-text-field>
            <v-text-field
              v-model="editingRole.code"
              label="Código"
              placeholder="Ej: ADM"
              required
              :rules="[v => !!v || 'El código es requerido']"
              @input="editingRole.code = (editingRole.code || '').toUpperCase()"
            ></v-text-field>
            <v-textarea
              v-model="editingRole.description"
              label="Descripción"
              placeholder="Descripción del rol"
              auto-grow
              rows="2"
            ></v-textarea>
            <v-checkbox
              v-model="editingRole.isActive"
              label="Activo"
              color="#1f9d63"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" flat color="#254f87">Cancelar</v-btn>
          <v-btn @click="saveRole" color="#e5252a" dark :loading="saving">
            <v-icon left small>save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog asignar menús -->
    <v-dialog max-width="640" persistent v-model="menusDialog" scrollable>
      <v-card class="role-dialog-card">
        <v-card-title class="role-dialog-title">
          <v-icon left color="#254f87">list</v-icon>
          Asignar menús a:&nbsp;<strong>{{ selectedRole.name }}</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 60vh;" class="pa-0">
          <div v-if="loadingMenus" class="menus-assign-loading">
            <v-progress-circular
              indeterminate
              color="#254f87"
              size="32"
            ></v-progress-circular>
            <p class="mt-2 grey--text">Cargando menús asignados...</p>
          </div>
          <template v-else>
            <div class="menus-assign-toolbar">
              <span class="menus-assign-counter">
                <strong>{{ selectedMenuIds.length }}</strong> de
                {{ availableMenus.length }} seleccionados
              </span>
              <v-spacer></v-spacer>
              <v-btn small flat color="#254f87" @click="selectAllMenus">
                <v-icon small left>done_all</v-icon>Todos
              </v-btn>
              <v-btn small flat color="#e5252a" @click="clearAllMenus">
                <v-icon small left>clear_all</v-icon>Ninguno
              </v-btn>
            </div>
            <v-divider></v-divider>
            <div class="menus-assign-list">
              <div
                v-for="root in menuTree"
                :key="root.id"
                class="menu-assign-group"
              >
                <label class="menu-assign-row menu-assign-row--root">
                  <input
                    type="checkbox"
                    :value="root.id"
                    v-model="selectedMenuIds"
                    class="menu-assign-checkbox"
                  />
                  <v-icon small color="#254f87">{{
                    root.icon || 'folder'
                  }}</v-icon>
                  <span class="menu-assign-label">{{ root.title }}</span>
                  <span class="menu-assign-route" v-if="root.route">{{
                    root.route
                  }}</span>
                </label>
                <div v-if="root.children.length" class="menu-assign-children">
                  <label
                    v-for="child in root.children"
                    :key="child.id"
                    class="menu-assign-row menu-assign-row--child"
                  >
                    <input
                      type="checkbox"
                      :value="child.id"
                      v-model="selectedMenuIds"
                      class="menu-assign-checkbox"
                    />
                    <v-icon small color="#c79a2b">{{
                      child.icon || 'subdirectory_arrow_right'
                    }}</v-icon>
                    <span class="menu-assign-label">{{ child.title }}</span>
                    <span class="menu-assign-route" v-if="child.route">{{
                      child.route
                    }}</span>
                  </label>
                </div>
              </div>
              <div
                v-if="!menuTree.length"
                class="pa-4 text-xs-center grey--text"
              >
                No hay menús disponibles para asignar.
              </div>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="menusDialog = false" flat color="#254f87"
            >Cancelar</v-btn
          >
          <v-btn @click="assignMenus" color="#e5252a" dark :loading="saving">
            <v-icon left small>save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <v-dialog max-width="350" persistent v-model="loading">
      <v-card>
        <v-card-text class="text-center py-4">
          <v-progress-circular
            color="#e5252a"
            indeterminate
          ></v-progress-circular>
          <p class="mt-2">Cargando...</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <delete-confirm-dialog
      v-model="deleteRoleDialog.show"
      :max-width="460"
      title="Eliminar rol"
      subtitle="Esta acción no se puede deshacer"
      :message="
        `¿Estás seguro de que deseas eliminar ${deleteRoleDialog.name}?`
      "
      warning="El rol quedará eliminado permanentemente del sistema."
      confirm-text="Sí, eliminar"
      @confirm="deleteRole"
    ></delete-confirm-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snack.show"
      :timeout="3500"
      :color="snack.color"
      right
      top
    >
      {{ snack.message }}
      <v-btn flat dark @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Api from '@/api/index'
import DeleteConfirmDialog from '@/components/DeleteConfirmDialog'

const ROLE_COLORS = {
  GEM: '#e5252a',
  ADM: '#254f87',
  COL: '#c79a2b',
  DIST: '#254f87',
  LAB: '#c79a2b',
  PAG: '#e5252a',
  ENT: '#1f9d63',
  CLI: '#7f56d9',
}

function extractList(resp) {
  if (!resp) return []
  if (Array.isArray(resp)) return resp
  if (Array.isArray(resp.items)) return resp.items
  if (resp.data) {
    if (Array.isArray(resp.data)) return resp.data
    if (Array.isArray(resp.data.items)) return resp.data.items
  }
  return []
}

export default {
  components: {
    DeleteConfirmDialog,
  },
  data() {
    return {
      roles: [],
      availableMenus: [],
      search: '',
      dialog: false,
      menusDialog: false,
      loading: false,
      saving: false,
      loadingMenus: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: 'name',
        descending: false,
      },
      rowsPerPageItems: [10, 25, 50, { text: 'Todos', value: -1 }],
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Código', value: 'code' },
        { text: 'Descripción', value: 'description' },
        { text: 'Estado', value: 'isActive' },
        { text: 'Acciones', sortable: false },
      ],
      editingRole: {
        id: null,
        name: '',
        code: '',
        description: '',
        isActive: true,
      },
      selectedRole: {},
      selectedMenuIds: [],
      deleteRoleDialog: {
        show: false,
        id: null,
        name: 'este rol',
      },
      snack: { show: false, color: 'info', message: '' },
    }
  },
  computed: {
    paginatedRoles() {
      if (this.pagination.rowsPerPage === -1) return this.roles
      const start = (this.pagination.page - 1) * this.pagination.rowsPerPage
      return this.roles.slice(start, start + this.pagination.rowsPerPage)
    },
    totalPages() {
      if (this.pagination.rowsPerPage === -1) return 1
      return Math.max(
        1,
        Math.ceil(this.roles.length / this.pagination.rowsPerPage)
      )
    },
    menuTree() {
      const map = {}
      const roots = []
      this.availableMenus.forEach(m => {
        map[m.id] = { ...m, children: [] }
      })
      this.availableMenus.forEach(m => {
        const node = map[m.id]
        if (m.parentId && map[m.parentId]) {
          map[m.parentId].children.push(node)
        } else {
          roots.push(node)
        }
      })
      const sortFn = (a, b) =>
        (a.order || 0) - (b.order || 0) || a.title.localeCompare(b.title)
      roots.sort(sortFn)
      roots.forEach(r => r.children.sort(sortFn))
      return roots
    },
  },
  mounted() {
    document.body.classList.add('admin-flush-top')
    this.loadRoles()
    this.loadMenus()
  },
  beforeDestroy() {
    document.body.classList.remove('admin-flush-top')
  },
  methods: {
    notify(message, color = 'info') {
      this.snack = { show: true, color, message }
    },
    roleColor(code) {
      return ROLE_COLORS[code] || '#5f6880'
    },
    formatDate(value) {
      if (!value) return ''
      const d = new Date(value)
      if (isNaN(d.getTime())) return value
      return d.toLocaleDateString('es-PA', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    },
    async loadRoles() {
      this.loading = true
      try {
        const term = (this.search || '').trim()
        const response = await Api.Role.getAll({ term })
        this.roles = extractList(response)
      } catch (error) {
        this.notify('Error al cargar los roles', 'error')
      } finally {
        this.loading = false
      }
    },
    onSearchClear() {
      this.search = ''
      this.loadRoles()
    },
    async loadMenus() {
      try {
        const response = await Api.Menu.getAll()
        this.availableMenus = extractList(response).map(m => ({
          ...m,
          id: Number(m.id),
          parentId: m.parentId != null ? Number(m.parentId) : null,
        }))
      } catch (error) {
        console.error('Error loading menus', error)
      }
    },
    openDialog(role = null) {
      if (role) {
        this.editingRole = { ...role }
      } else {
        this.editingRole = {
          id: null,
          name: '',
          code: '',
          description: '',
          isActive: true,
        }
      }
      this.dialog = true
    },
    async openMenusDialog(role) {
      this.selectedRole = role
      this.selectedMenuIds = []
      this.menusDialog = true
      this.loadingMenus = true
      try {
        const response = await Api.Role.getMenus(role.id)
        if (this.isHttpError(response)) throw new Error('http')
        this.selectedMenuIds = this.extractMenuIds(response)
      } catch (error) {
        this.notify('No se pudieron cargar los menús asignados al rol', 'error')
      } finally {
        this.loadingMenus = false
      }
    },
    extractMenuIds(response) {
      if (!response) return []
      // Caso 1: { menuIds: [1, 2, 3] } o { data: { menuIds: [...] } }
      if (Array.isArray(response.menuIds)) return response.menuIds.map(Number)
      if (response.data && Array.isArray(response.data.menuIds)) {
        return response.data.menuIds.map(Number)
      }
      // Caso 2: array de IDs directo [1, 2, 3]
      if (
        Array.isArray(response) &&
        response.every(v => typeof v !== 'object')
      ) {
        return response.map(Number)
      }
      // Caso 3: array de objetos [{id, title, ...}] o [{menuId, ...}]
      const list = extractList(response)
      return list
        .map(m => {
          if (typeof m === 'number' || typeof m === 'string') return Number(m)
          return Number(m.menuId != null ? m.menuId : m.id)
        })
        .filter(id => Number.isFinite(id))
    },
    isHttpError(response) {
      return !!(
        response &&
        typeof response.status === 'number' &&
        response.status >= 400
      )
    },
    selectAllMenus() {
      this.selectedMenuIds = this.availableMenus.map(m => m.id)
    },
    clearAllMenus() {
      this.selectedMenuIds = []
    },
    async saveRole() {
      if (!this.$refs.form.validate()) return
      this.saving = true
      try {
        const response = await Api.Role.save(this.editingRole)
        if (this.isHttpError(response)) throw new Error('http')
        this.notify('Rol guardado correctamente', 'success')
        this.dialog = false
        this.loadRoles()
      } catch (error) {
        this.notify('Error al guardar el rol', 'error')
      } finally {
        this.saving = false
      }
    },
    openDeleteRoleModal(role) {
      this.deleteRoleDialog = {
        show: true,
        id: role.id,
        name: role && role.name ? role.name : 'este rol',
      }
    },
    async deleteRole() {
      const id = this.deleteRoleDialog.id
      if (id == null) return
      this.deleteRoleDialog.show = false
      try {
        const response = await Api.Role.delete(id)
        if (this.isHttpError(response)) throw new Error('http')
        this.notify('Rol eliminado correctamente', 'success')
        this.loadRoles()
      } catch (error) {
        this.notify('Error al eliminar el rol', 'error')
      }
    },
    async assignMenus() {
      this.saving = true
      try {
        const response = await Api.Role.assignMenus(
          this.selectedRole.id,
          this.selectedMenuIds
        )
        if (this.isHttpError(response)) throw new Error('http')
        const total = this.selectedMenuIds.length
        const msg =
          total === 0
            ? `Se quitaron todos los menús de ${this.selectedRole.name}`
            : `Se asignaron ${total} menú(s) a ${this.selectedRole.name}`
        this.notify(msg, 'success')
        this.menusDialog = false
      } catch (error) {
        this.notify('Error al asignar menús', 'error')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.roles-list {
  --brand-primary: #e5252a;
  --brand-secondary: #254f87;
  --brand-accent: #c79a2b;
  --surface: #ffffff;
  --surface-soft: #f6f8fc;
  --text-primary: #172133;
  --text-muted: #5f6880;
  --border-soft: #e4e8f1;
  background: #f8fafc;
  min-height: 100vh;
  padding-bottom: 16px;
}

.list-hero {
  padding: 4px 0 8px;
}

.list-crumb {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.list-title {
  margin: 4px 0;
  font-size: 32px;
  line-height: 1.1;
  color: #0f172a;
  font-weight: 700;
}

.list-subtitle {
  margin: 0;
  font-size: 14px;
  color: #475569;
}

.roles-panel {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  background: #ffffff;
}

.roles-card__toolbar {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.roles-search {
  max-width: 100%;
}

.btn-nuevo {
  border-radius: 8px;
}

.roles-content-wrap {
  background: var(--surface-soft);
}

.roles-table {
  background: var(--surface);
}

.roles-table ::v-deep thead th {
  color: #64748b !important;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  background: #f8fafc;
}

.roles-table ::v-deep tbody td {
  color: #334155;
  font-size: 14px;
  border-bottom: 1px solid #eef2f7;
}

.roles-table ::v-deep tbody tr:hover td {
  background: #f8fafc;
}

.role-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.role-color-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.role-code-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  background: rgba(37, 79, 135, 0.08);
  color: var(--brand-secondary);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.05em;
  border-radius: 6px;
}

.role-code-badge--inverse {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

.status-chip {
  font-weight: 700;
}

.status-chip--active {
  background-color: #1f9d63 !important;
}

.status-chip--inactive {
  background-color: #d94848 !important;
}

.table-action-btn {
  margin: 0 2px;
}

.table-action-btn--edit {
  border: 1px solid rgba(37, 79, 135, 0.3) !important;
  color: #254f87 !important;
  background: rgba(37, 79, 135, 0.1) !important;
  box-shadow: none !important;
}

.table-action-btn--menus {
  border: 1px solid rgba(199, 154, 43, 0.3) !important;
  color: #c79a2b !important;
  background: rgba(199, 154, 43, 0.1) !important;
  box-shadow: none !important;
}

.table-action-btn--delete {
  border: 1px solid rgba(229, 37, 42, 0.3) !important;
  color: #e5252a !important;
  background: rgba(229, 37, 42, 0.1) !important;
  box-shadow: none !important;
}

/* === Mobile === */
.roles-mobile-list {
  background: var(--surface-soft);
}

.role-mobile-card {
  border-radius: 14px;
  border: 1px solid var(--border-soft);
  box-shadow: 0 10px 28px rgba(20, 37, 70, 0.08);
  overflow: hidden;
}

.role-mobile-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 14px;
  background: linear-gradient(
    135deg,
    var(--role-color, #254f87),
    rgba(0, 0, 0, 0.18)
  );
  color: #ffffff;
}

.role-mobile-card__head-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.role-mobile-card__title {
  margin: 0;
  font-weight: 700;
  font-size: 15px;
  color: #ffffff;
}

.role-mobile-card__body {
  padding: 12px 14px;
}

.role-mobile-card__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
}

.role-mobile-card__row .label {
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 600;
}

.role-mobile-card__row .value {
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  text-align: right;
}

.role-mobile-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 14px 14px;
  flex-wrap: wrap;
}

.mobile-action-btn {
  border-radius: 9px;
}

.mobile-pagination {
  display: flex;
  justify-content: center;
  padding: 12px 0 4px;
}

.mobile-pagination ::v-deep .v-pagination__item--active {
  background-color: var(--brand-primary) !important;
  color: #ffffff !important;
}

@media (max-width: 960px) {
  .roles-toolbar {
    padding: 10px;
  }

  .roles-search {
    max-width: none;
  }
}
</style>

<style>
/* === Estilos del diálogo (no scoped — el v-dialog se portala fuera del componente) === */
.role-dialog-card {
  border-radius: 14px;
  overflow: hidden;
}

.role-dialog-title {
  background: linear-gradient(
    90deg,
    rgba(37, 79, 135, 0.1),
    rgba(199, 154, 43, 0.1)
  );
  color: #254f87;
  font-weight: 700;
  font-size: 17px !important;
  padding: 16px 24px !important;
}

.role-dialog-title strong {
  color: #e5252a;
  margin-left: 4px;
}

.menus-assign-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 16px;
  background: #ffffff;
}

.menus-assign-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(
    90deg,
    rgba(37, 79, 135, 0.06),
    rgba(199, 154, 43, 0.04)
  );
}

.menus-assign-counter strong {
  color: #e5252a;
  font-size: 14px;
}

.menus-assign-counter {
  font-size: 12px;
  font-weight: 600;
  color: #254f87;
}

.menus-assign-list {
  padding: 8px 16px 16px;
  background: #ffffff;
}

.menu-assign-group + .menu-assign-group {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed rgba(37, 79, 135, 0.12);
}

.menu-assign-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.menu-assign-row:hover {
  background: rgba(37, 79, 135, 0.05);
}

.menu-assign-row--root {
  font-weight: 700;
  color: #172133;
}

.menu-assign-row--child {
  color: #4b5563;
  font-size: 13px;
}

.menu-assign-children {
  margin-left: 18px;
  padding-left: 8px;
  border-left: 2px dashed rgba(37, 79, 135, 0.18);
}

.menu-assign-checkbox {
  width: 16px;
  height: 16px;
  accent-color: #e5252a;
  cursor: pointer;
}

.menu-assign-label {
  flex: 1;
}

.menu-assign-route {
  font-size: 11px;
  color: #5f6880;
  font-weight: 500;
  background: rgba(37, 79, 135, 0.06);
  padding: 2px 6px;
  border-radius: 4px;
}
</style>
